export const CROSS_WINDOW_MESSAGE_PREFIX = 'cb-bookingengine-';
